import { render, staticRenderFns } from "./add-venture-Partner-modal.vue?vue&type=template&id=b552ad4e"
import script from "./add-venture-Partner-modal.vue?vue&type=script&lang=js"
export * from "./add-venture-Partner-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports